import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/MauroBonnaLayout.vue'
import AuthGuard from "./AuthGuard";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/',
    name: 'layout',
    redirect: 'home',
    component: Layout,
    beforeEnter: AuthGuard,
    children: [
      {
        path: '/',
        name: 'DASHBOARD',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Home.vue'),
      },
      {
        path: '/editorial',
        name: 'EDITORIAL',
        component: () => import(/* webpackChunkName: "demo" */ '../views/editorial/ListaEditorial.vue'),
      },
      {
        path: '/editorial/:id/publicacao',
        name: 'EDITORIAL :: Publicação',
        component: () => import(/* webpackChunkName: "demo" */ '../views/editorial/AssociarEditorial.vue'),
      },
      {
        path: '/publicacoes',
        name: 'PUBLICAÇÕES',
        component: () => import(/* webpackChunkName: "demo" */ '../views/publicacao/Lista.vue'),
      },
      {
        path: '/autor',
        name: 'AUTOR',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Autor.vue'),
      },
      {
        path: '/anuncio',
        name: 'ANÚNCIO',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Anuncio.vue'),
      },
      {
        path: '/push',
        name: 'PUSH',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Push.vue'),
      },
      {
        path: '/configuracoes',
        name: 'CONFIGURAÇÕES',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Configuracoes.vue'),
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
